export const COLLAPSE_CHANGE = 'COLLAPSE_CHANGE';
export const COLLAPSE_OPEN_DRAWER = 'COLLAPSE_OPEN_DRAWER';
export const CHANGE_OPEN_KEYS = 'CHANGE_OPEN_KEYS';
export const TOGGLE_ALL = 'TOGGLE_ALL';
export const CHANGE_CURRENT = 'CHANGE_CURRENT';
export const CLEAR_MENU = 'CLEAR_MENU';
